import { Create, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HttpError } from "@pankod/refine-core";

const schema = Yup.object({
  tag_reward_id: Yup.number(),
  type: Yup.string().required(),
  ref1: Yup.string().optional(),
  ref2: Yup.string().optional(),
  ref3: Yup.string().optional(),
  ref4: Yup.string().optional(),
  ref5: Yup.string().optional(),
});

type Schema = Yup.InferType<typeof schema>;

export const TagRewardEdit = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<Schema, HttpError, Schema>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tag_reward_id")}
          required
          error={!!errors.type}
          helperText={errors.type?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tag Condition Id"
          disabled
        />
        <TextField
          {...register("type")}
          required
          error={!!errors.type}
          helperText={errors.type?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Type"
        />
        <TextField
          {...register("ref1")}
          error={!!errors.ref1}
          helperText={errors.ref1?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Ref 1"
        />
        <TextField
          {...register("ref2")}
          error={!!errors.ref2}
          helperText={errors.ref2?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Ref 2"
        />
        <TextField
          {...register("ref3")}
          error={!!errors.ref3}
          helperText={errors.ref3?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Ref 3"
        />
        <TextField
          {...register("ref4")}
          error={!!errors.ref4}
          helperText={errors.ref4?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Ref 4"
        />
        <TextField
          {...register("ref5")}
          error={!!errors.ref5}
          helperText={errors.ref5?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Ref 5"
        />
      </Box>
    </Create>
  );
};
